import React, { useState, useMemo } from 'react';
import { FaSpinner } from 'react-icons/fa';
import DealTagValidation from '../../Tools/DealTagValidation';
import DealTagCard from './DealTagCard';
import { PROJECT_TYPE_LABELS } from '../hooks/useProjectTypeFilter';
import styles from '../ManagePage.module.css';

// Deal-tag check history for the Manage page's deal-tag filter view.
// Data comes from useDealTagHistory in ManagePage so the merged default grid
// and this view share one fetch. On selection, renders the batch's validation
// detail inline.
const DealTagSection = ({ data }) => {
  const { loading, error, batches } = data;
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const hasBatches = batches.length > 0;

  const selectedBatch = useMemo(
    () => (selectedBatchId ? batches.find(b => b.task_id === selectedBatchId) : null),
    [selectedBatchId, batches]
  );

  if (selectedBatch) {
    return (
      <div className={styles.section}>
        <DealTagValidation
          key={selectedBatch.task_id}
          batch={selectedBatch}
          onBack={() => setSelectedBatchId(null)}
        />
      </div>
    );
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionHeaderTitle}>
          <span className={styles.allProjectsTitle}>{PROJECT_TYPE_LABELS.deal_tag} ({batches.length})</span>
        </div>
      </div>
      {loading && (
        <div className={styles.loading}><FaSpinner className={styles.spinner} /></div>
      )}
      {error && !loading && (
        <div className={styles.error}>{error}</div>
      )}
      {!loading && !error && !hasBatches && (
        <div className={styles.emptyState}>
          <h3>No deal tag history</h3>
          <p>Check deal tags for your ASINs to see results here.</p>
        </div>
      )}
      {!loading && !error && hasBatches && (
        <div className={styles.smallCardsGrid}>
          {batches.map((batch) => (
            <DealTagCard
              key={batch.task_id}
              batch={batch}
              onClick={() => setSelectedBatchId(batch.task_id)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DealTagSection;
